import { ReservationsCoverageDataWithId } from "../types";

export const isReservationsCoverageDataWithId = (
  data: any,
): data is ReservationsCoverageDataWithId => {
  return !!data?.covered_hours;
};
